import React, { useCallback, useEffect } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withContainer = Component => ({ prefix }) => {
  const { openNotification } = hooks.useNotification()
  const setFormValues = hooks.useFormChange()
  const [toggleFavorite] = hooks.useModelFunction('address', 'toggleFavorite')

  const prefix_field = prefix === 'source' ? 'src' : 'dest'
  const comment = hooks.useFieldValue(`info.${prefix_field}_comment`)

  const [{ user_id, selected_user, isB2B, isReadOnly, isManagingRecord }, setFormState] = hooks.useFormState()

  const [addressDetails] = hooks.useFormState(`details.${prefix}`)
  const [save_comment, setSaveComment] = hooks.useFormState(`save_comment.${prefix}`)
  const [favorite_address, setFavoriteAddress] = hooks.useFormState(`favorite_address.${prefix}`)

  const [
    first_name,
    last_name,
    name,
    gsm,
    companyuser_id,
    commercial_formula,
    schedule_type,
    source,
    destination,
    vehicle_count,
    guest
  ] = hooks.useFieldValues([
    'user.first_name',
    'user.last_name',
    'user.name',
    'user.gsm',
    'user.companyuser',
    'user.commercial_formula',
    'schedule_type',
    'source',
    'destination',
    'vehicle_count',
    'guest'
  ])

  const addressFieldValue = hooks.useFieldValue(prefix)

  const [address] = hooks.useModel('address', [addressDetails?.address_id], { single: true })
  const [companyuser] = hooks.useModel('companyuser', [companyuser_id], { populate: ['user.customerinfo', 'user.info', 'user.auth'], single: true })
  const [poi] = hooks.useModel('poi', [addressDetails?.poi_id || addressDetails?.poi?.poi_id], { single: true, populate: ['type.reservationinfo', 'type.authorized_pois'] })

  const owner = selected_user || user_id
  const required_additional_info = poi?.required_additional_info
  const reservationinfo = poi?.type?.reservationinfo
  const reservationinfo_id = reservationinfo?.reservationinfo_id
  const pickup_at_transport = _.find(poi?.type?.authorized_pois, a_poi => a_poi?.commercial_formula === commercial_formula)?.pickup_at_transport
  const display_additional_info = !!reservationinfo && schedule_type === 'planned' && !!required_additional_info && !!pickup_at_transport
  const additional_info_required = !!reservationinfo && schedule_type === 'planned' && !!required_additional_info
  const display_swap_button = prefix === 'source' && !!source && !!destination && !isReadOnly
  const isFavorite = !!address?.favorite
  const disabledIconButton = isReadOnly || !user_id || !!_.isEmpty(addressFieldValue)
  const guest_booking = companyuser?.guest_booking

  const onAddressResolve = useCallback(
    Callbacks.handleOnAddressResolve(setFormValues, setFormState, prefix, source, destination)
    , [setFormValues, setFormState, prefix, source, destination])
  const handleSetFavoriteAddress = useCallback(
    Callbacks.handleSetFavoriteAddressHandler(openNotification, owner, addressDetails, favorite_address, setFavoriteAddress, toggleFavorite)
    , [openNotification, owner, addressDetails, favorite_address, setFavoriteAddress, toggleFavorite])
  const handleReplaceComment = useCallback(Callbacks.handleReplaceCommentHandler(openNotification, save_comment, setSaveComment, comment, addressDetails), [openNotification, save_comment, setSaveComment, comment, addressDetails])
  const handleGuestChange = useCallback(Callbacks.guestChangeHandler(setFormValues, companyuser, prefix), [setFormValues, companyuser, prefix])
  const handleIsReservationinfoChange = useCallback(Callbacks.handleIsReservationinfoChangeHandler(poi, setFormState), [poi, setFormState])
  const swapAddress = useCallback(Callbacks.handleSwapAddress(source, destination, setFormValues), [source, destination, setFormValues])

  useEffect(() => {
    if (!!isFavorite) {
      setFavoriteAddress(address)
    }
  }, [isFavorite])

  useEffect(() => {
    setFormState({
      source_reservationinfo_id: !!reservationinfo_id ? reservationinfo_id : null
    })
  }, [reservationinfo_id])

  useEffect(() => {
    if (!!user_id || !!isManagingRecord || prefix !== 'source') return
    if ((!!last_name || !!name) && !!gsm)
      setFormValues([
        { field: 'loads.src_phone', value: gsm },
        { field: 'loads.src_contact', value: _.compact([first_name, last_name]).join(' ') || name }
      ])

  }, [last_name, name, gsm, user_id])

  const mergedProps = {
    commercial_formula,
    schedule_type,
    companyuser_id,
    owner,
    prefix,
    save_comment,
    favorite_address,
    prefix_field,
    vehicle_count,
    reservationinfo,
    guest_booking,
    guest,
    disabledIconButton,
    display_swap_button,
    display_additional_info,
    additional_info_required,
    isReadOnly,
    isB2B,
    handleIsReservationinfoChange,
    handleReplaceComment,
    handleSetFavoriteAddress,
    onAddressResolve,
    handleGuestChange,
    swapAddress
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer